const sectionTitles: Record<string, { title: string; desc: string }> = {
  dashboard: { title: "数据总览", desc: "协会核心数据一览" },
  "member-audit": { title: "会员审核", desc: "审核新会员注册申请" },
  "member-list": { title: "会员列表", desc: "查看与管理所有会员" },
  "member-points-import": { title: "导入会员积分", desc: "按身份证号导入积分，并累加各活动类型参加次数" },
  "news-publish": { title: "发布资讯", desc: "编写并发布协会新闻公告" },
  "news-list": { title: "资讯列表", desc: "管理所有已发布与草稿资讯" },
  "activity-list": { title: "活动管理", desc: "创建和管理所有协会活动" },
  "linked-activities": { title: "关联活动", desc: "上下级协会授权报名的活动与积分配置" },
  "registration-audit": { title: "报名审核", desc: "审核会员活动报名申请" },
};

interface Props {
  activeSection: string;
  onToggleSidebar: () => void;
  /** 刷新租户后台共享数据（会员、申请、报名、活动/资讯/投票/文件及各类配置缓存） */
  onRefreshData?: () => void;
  refreshing?: boolean;
}

export default function AdminTopbar({
  activeSection,
  onToggleSidebar,
  onRefreshData,
  refreshing = false,
}: Props) {
  const info = sectionTitles[activeSection] || { title: "管理后台", desc: "" };
  const now = new Date().toLocaleDateString("zh-CN", { year: "numeric", month: "long", day: "numeric" });

  return (
    <header className="h-16 bg-white border-b border-gray-100 flex items-center justify-between px-6 flex-shrink-0">
      <div className="flex items-center gap-4">
        <button
          onClick={onToggleSidebar}
          className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 cursor-pointer transition-colors lg:hidden"
        >
          <i className="ri-menu-line text-gray-600"></i>
        </button>
        <div>
          <h2 className="text-base font-bold text-gray-900 leading-tight">{info.title}</h2>
          <p className="text-xs text-gray-400 leading-tight">{info.desc}</p>
        </div>
      </div>

      <div className="flex items-center gap-4">
        <span className="text-xs text-gray-400 hidden md:block">{now}</span>

        {onRefreshData ? (
          <button
            type="button"
            onClick={() => onRefreshData()}
            disabled={refreshing}
            title="重新从服务器加载租户数据"
            className="flex items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-600 hover:border-red-200 hover:text-red-600 hover:bg-red-50 cursor-pointer transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <i className={`ri-refresh-line text-base ${refreshing ? "animate-spin" : ""}`} />
            <span className="hidden sm:inline">{refreshing ? "刷新中…" : "刷新数据"}</span>
          </button>
        ) : null}

        {/* Notification Bell */}
        <button className="relative w-9 h-9 flex items-center justify-center rounded-xl hover:bg-gray-100 cursor-pointer transition-colors">
          <i className="ri-notification-3-line text-gray-600 text-lg"></i>
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full"></span>
        </button>

        {/* Admin Avatar */}
        <div className="w-9 h-9 flex items-center justify-center bg-red-600 rounded-full cursor-pointer">
          <i className="ri-admin-line text-white text-sm"></i>
        </div>
      </div>
    </header>
  );
}
